import { Descriptor } from "./Descriptor"

export class Event extends Descriptor {
  transitionDetail: any //  TODO: ADD TransitionDetail
  isAvailableToHaulerEmployee?: boolean | null

  constructor(
    name: string,
    labelKey: string,
    icon: string,
    transitionDetail?: any | null,
    rank?: number | null,
    style?: string | null,
    emphasized?: boolean | null,
    isAvailableToHaulerEmployee?: boolean | null,
  ) {
    super(name, labelKey, icon, rank, style, emphasized)
    this.isAvailableToHaulerEmployee = isAvailableToHaulerEmployee
    this.transitionDetail = transitionDetail
  }
}
